export function convertToPNG(src: HTMLImageElement, color: string) {
  return new Promise((resolve) => {
    const img = new Image();

    img.onload = () => {
      let { clientWidth, clientHeight } = src;
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      if (canvas && context) {
        clientWidth *= 4;
        clientHeight *= 4;
        if (src.classList.contains('pdfLogoImg')) {
          clientWidth *= 5;
          clientHeight *= 5;
        }

        canvas.width = clientWidth;
        canvas.height = clientHeight;
        context.fillStyle = color; // <- background color
        // draw background / rect on entire canvas
        context.fillRect(0, 0, canvas.width, canvas.height);
        // eslint-disable-next-line no-param-reassign
        src.onload = resolve;
        context.drawImage(img, 0, 0, clientWidth, clientHeight);
        // eslint-disable-next-line no-param-reassign
        src.src = canvas.toDataURL('image/jpeg');
      }
    };

    img.crossOrigin = 'Anonymous';
    img.src = src.src;
  });
}

export const b64SVGtoB64PNG = (svgBase64: string): Promise<string> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = svgBase64;

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const width = img.width * 5;
      const height = img.height * 5;
      canvas.width = width;
      canvas.height = height;

      const ctx = canvas.getContext('2d');
      ctx?.drawImage(img, 0, 0, width, height);

      resolve(canvas.toDataURL('image/png'));
    };
  });
};
